module.exports = __webpack_public_path__ + "static/media/OXX.4794a019.png";